import { useEffect } from "react";
import { useNavigate } from "@remix-run/react";
import { useRoutePrefix } from "~/hooks/useRoutePrefix";
import { questions } from "~/utils/quiz/questionsData";
import { QuestionLayout } from "../QuestionLayout";
import { ProgressBar } from "../ProgressBar";

import * as styles from "./index.module.scss";

export function QuizLayout({ step }) {
  const navigate = useNavigate();
  const { QUIZ_RESULTS_ROUTE } = useRoutePrefix();

  const quizLength = questions.length;
  const isLastStep = step === quizLength;
  const currentQuestion = questions[step - 1];

  useEffect(() => {
    if (!currentQuestion) {
      navigate(QUIZ_RESULTS_ROUTE);
    }
  }, [currentQuestion]);

  // Hide the help widget to avoid interference with CTAs
  // useHideHelpButton();

  /**
   * Render a loader or feedback if answers are not available
   * TODO: maybe change for a loader ?
   */
  // if (!answers) return null;

  if (!currentQuestion) {
    return null;
  }

  return (
    <div className={styles.quizWrapper} data-testid="quiz-wrapper">
      <ProgressBar quizLength={quizLength} step={step} />
      <QuestionLayout
        question={currentQuestion}
        isLastQuestion={isLastStep}
        step={step}
      />
    </div>
  );
}
